var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var _input, _cursor;
export var Token;
(function (Token) {
    Token["MultiplexOpen"] = "[";
    Token["MultiplexClose"] = "]";
    Token["SyncOpen"] = "(";
    Token["SyncSep"] = ",";
    Token["SyncClose"] = ")";
    Token["PassingOpen"] = "<";
    Token["PassingClose"] = ">";
    Token["PassingSep"] = "|";
    Token["Number"] = "1";
    Token["SyncRepeatSwap"] = "*";
    Token["EOF"] = "";
})(Token || (Token = {}));
export class Lexer {
    constructor(input) {
        _input.set(this, void 0);
        _cursor.set(this, 0);
        __classPrivateFieldSet(this, _input, input.toLowerCase());
    }
    nextToken() {
        var _a;
        const ws = this.eatWS();
        if (__classPrivateFieldGet(this, _cursor) === __classPrivateFieldGet(this, _input).length) {
            return {
                token: Token.EOF,
                leadingWS: ws,
            };
        }
        const ch = __classPrivateFieldGet(this, _input).charAt((__classPrivateFieldSet(this, _cursor, (_a = +__classPrivateFieldGet(this, _cursor)) + 1), _a));
        if ([
            Token.MultiplexOpen,
            Token.MultiplexClose,
            Token.SyncOpen,
            Token.SyncSep,
            Token.SyncClose,
            Token.PassingOpen,
            Token.PassingClose,
            Token.PassingSep,
            Token.SyncRepeatSwap,
        ].includes(ch)) {
            return {
                token: ch,
                leadingWS: ws,
            };
        }
        const chCode = ch.charCodeAt(0);
        const code0 = "0".charCodeAt(0);
        const code9 = "9".charCodeAt(0);
        const codea = "a".charCodeAt(0);
        const codez = "z".charCodeAt(0);
        if ((chCode >= code0 && chCode <= code9) ||
            (chCode >= codea && chCode <= codez)) {
            let ret = {
                token: Token.Number,
                value: chCode <= code9 ? chCode - code0 : chCode - codea + 10,
                leadingWS: ws,
            };
            return ret;
        }
        throw new Error(`unexpected token: ${ch}`);
    }
    eatWS() {
        let ws = false;
        while (__classPrivateFieldGet(this, _cursor) < __classPrivateFieldGet(this, _input).length) {
            const ch = __classPrivateFieldGet(this, _input).charAt(__classPrivateFieldGet(this, _cursor));
            if (ch === " " || ch === "\t" || ch === "\n" || ch === "\r") {
                __classPrivateFieldSet(this, _cursor, +__classPrivateFieldGet(this, _cursor) + 1);
                ws = true;
                continue;
            }
            break;
        }
        return ws;
    }
}
_input = new WeakMap(), _cursor = new WeakMap();
